import { getLogRepository, getLogsRepository } from "../Infrastructure/Logs.repository";

export async function getLogsLogic(params) {
  return getLogsRepository(params);
}
export async function getLogLogic(id) {
  return getLogRepository(id);
}